import { DateTime } from 'luxon';
import { CitizenshipFormVM } from 'mutation/view-models/registration-citizenship';
import { DatiAggiuntiviSide, ModelEventoDTO } from 'shell/models/act-category-list';
import { ActType } from 'shell/constants/act-type';
import { ItemVM } from 'shell/view-models/item';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';

export const transformerNewCitizenshipDPR = (
  modelEventoDTO?: ModelEventoDTO,
  datiAggiuntiviSide?: DatiAggiuntiviSide,
  subEvento?: string,
  motivoVariazioneCittadinanza?: ItemVM<MotArtCitizenship>
): CitizenshipFormVM | undefined => {
  if (!modelEventoDTO) {
    return;
  }

  const idAnscSplit = modelEventoDTO.idAnsc?.split('-') || [];

  return {
    reasonCitizenship: subEvento,
    toDPR: {
      article: motivoVariazioneCittadinanza,
      dateBuying: modelEventoDTO.dataformazione
        ? DateTime.fromISO(modelEventoDTO.dataformazione).plus({ day: 1 })
        : null,
      dateDPR: datiAggiuntiviSide?.dataDecreto
        ? DateTime.fromISO(datiAggiuntiviSide?.dataDecreto)
        : null,
      dateOath: datiAggiuntiviSide?.dataGiuramento
        ? DateTime.fromISO(datiAggiuntiviSide?.dataGiuramento)
        : null,
      italian: datiAggiuntiviSide?.idComuneRegistrazione
        ? {
            municipality: {
              description: datiAggiuntiviSide.nomeComuneRegistrazione || '',
              id: datiAggiuntiviSide.idComuneRegistrazione || '',
              province: datiAggiuntiviSide.siglaProvinciaRegistrazione || '',
              provinceCode: datiAggiuntiviSide.idProvinciaRegistrazione,
            },
          }
        : undefined,
      actType: ActType.AttoDigitale,
      digital: {
        documentDate: modelEventoDTO.dataformazione
          ? DateTime.fromISO(modelEventoDTO.dataformazione)
          : null,
        istatCode: datiAggiuntiviSide?.idComuneRegistrazione || '',
        municipality: datiAggiuntiviSide?.idComuneRegistrazione
          ? {
              description: datiAggiuntiviSide.nomeComuneRegistrazione || '',
              id: datiAggiuntiviSide.idComuneRegistrazione || '',
              province: datiAggiuntiviSide.siglaProvinciaRegistrazione || '',
              provinceCode: datiAggiuntiviSide.idProvinciaRegistrazione,
            }
          : undefined,
        year: idAnscSplit[0] || '',
        nationalNumber: idAnscSplit[1] || '',
        numberMunicipality: idAnscSplit[2] || '',
        idAnsc: modelEventoDTO.idAnsc,
      },
    },
  };
};
